export const GET_SESSION_RATES = "GET_SESSION_RATES";
export const GET_SESSION_RATE_BY_ID = "GET_SESSION_RATE_BY_ID";
export const UPDATE_SESSION_RATE = "UPDATE_SESSION_RATE";
export const DELETE_SESSION_RATE = "DELETE_SESSION_RATE";
export const CREATE_SESSION_RATE = "CREATE_SESSION_RATE";
